import crearPerfilEmpresarilService from '../services/crearPerfilEmpresarial.js';

export const useCrearPerfilEmpresarial = () => {

    const getData = () => crearPerfilEmpresarilService.getData();

    return { getData };
}